module.exports = __webpack_public_path__ + "img/photo_240750780_1.3c7f66b7.jpg";